import React from "react";
import "./ParlayStatusCircles.style.scss";
import {ParlayType} from "../../constants/PickXEnums";

const ParlayStatusCircles = ({parlay, contests}) => {

    let content = null;
    switch (parlay.parlayType) {
        case ParlayType.CreateYourOwn:
            const min = 3;
            const totalContests = parlay.contestIds.length;
            const numMissing = totalContests < min ? min - totalContests : 0;
            content = <>
                {[...Array(totalContests).fill(0),
                  ...Array(numMissing).fill(-1)]
                    .map((s, x) => <div key={x + "-missing"}
                                        className={"result _" + s}></div>)}
            </>;
            break;
        case ParlayType.CreateFromPreSelected:
            content = contests.map(contest => {
                const contestPick = parlay.ContestsPicks[contest.Id];
                return <div key={contest.Id}
                            className={"result _" + (contestPick.Pick > 0 ? "0 gold-background" : "-1")}></div>
            });
            break;
        case ParlayType.UserParlay:
            content = Object.entries(parlay.ContestsPicks)
                .map(([key, contestPick]) => <div key={key}
                                                  className={"result _" + contestPick.Result + " " + (contestPick.Result === 0 ? "gold-background" : "")}></div>)
            break;
    }
    return <div className="ParlayStatusCircles">{content}</div>
}
export default ParlayStatusCircles;